import { memo } from "react";
import { Div, useBetterHtmlContext, useTheme } from "react-better-html";

import AppLogo from "../../AppLogo";

function LegalHeader() {
   const theme = useTheme();
   const { app } = useBetterHtmlContext();

   return (
      <>
         <Div
            as="header"
            position="fixed"
            width="100%"
            height={theme.styles.headerHeight}
            top={0}
            left={0}
            backgroundColor={theme.colors.backgroundContent}
            borderBottom={`solid ${theme.styles.borderWidth}px ${theme.colors.border}`}
            padding={theme.styles.space}
            transition={theme.styles.transition}
            zIndex={9}
         >
            <Div.row
               width="100%"
               maxWidth={app.contentMaxWidth}
               height="100%"
               alignItems="center"
               justifyContent="space-between"
               gap={theme.styles.space}
               marginInline="auto"
            >
               <AppLogo />
            </Div.row>
         </Div>

         <Div width="100%" height={theme.styles.headerHeight} />
      </>
   );
}

export default memo(LegalHeader);
